function EmployeeDirectoryDocumentation() {
  return <>Directory Documentation</>;
}

export default EmployeeDirectoryDocumentation;
